import { styled } from '@mui/material';
import Chip from 'components/Chip';
import { round } from 'lodash';
import { Tooltip } from '@mui/material';
import { Api } from 'further-types/investment';

const StyledDiv = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
});

type Props = {
  fee: Api.GetInvestmentFeesResponse['fees'][number];
};

const FeePercentageContainer = ({ fee }: Props) => {
  return (
    <StyledDiv>
      {round(fee?.grossFeePercentage, 2)}
      <Tooltip
        title={
          <>
            As the <i>Unrealised asset cost</i> is lower than the{' '}
            <i>Minimum fee</i>, the <i>Minimum fee</i> has been used.
          </>
        }
        arrow
      >
        <span>
          {fee.minimumFeeApplied && (
            <Chip variant="disabled" small>
              <span style={{ whiteSpace: 'nowrap' }}>Minimum fee</span>
            </Chip>
          )}
        </span>
      </Tooltip>
    </StyledDiv>
  );
};

export default FeePercentageContainer;
